'use client';

import classnames from 'classnames';
import { useState } from 'react';

interface SubTabsProps {
  className?: string;
  tabs: Tabs;
  onClick?: (index: number) => void;
  active?: number;
}

interface Tab {
  label: string;
  value?: string | number;
}

type Tabs = Tab[];

const SubDividerTabs = ({ className, tabs, onClick, active }: SubTabsProps) => {
  const [current, setCurrent] = useState(0);

  const onClickTab = (index: number) => () => {
    setCurrent(index);
    onClick?.(index);
  };

  return (
    <ul className={classnames('flex items-center text-base/none tracking-[0.67px] text-[#848d97]', className)}>
      {tabs?.map(({ label }, index) => {
        const isActive = active ? active === index : index === current;

        return (
          <li
            key={label}
            className={classnames('cursor-pointer', 'border-[#e2e8f1] pr-2', {
              'border-l-2': index !== 0,
              'pl-2': index !== 0,
              'text-[#e03f19]': isActive
            })}
            onClick={onClickTab(index)}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
};

export default SubDividerTabs;
